/**
 * @generated SignedSource<<070f76117f2e3065ebc6bb8c9a662ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SearchedUserList_Query$variables = {
  searchText?: string | null;
};
export type SearchedUserList_QueryVariables = SearchedUserList_Query$variables;
export type SearchedUserList_Query$data = {
  readonly viewers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly company: string | null;
        readonly email: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
  };
};
export type SearchedUserList_QueryResponse = SearchedUserList_Query$data;
export type SearchedUserList_Query = {
  variables: SearchedUserList_QueryVariables;
  response: SearchedUserList_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchText"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchText"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "viewers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "company",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchedUserList_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchedUserList_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59bbf78615ae641ed29a905095c6a997",
    "id": null,
    "metadata": {},
    "name": "SearchedUserList_Query",
    "operationKind": "query",
    "text": "query SearchedUserList_Query(\n  $searchText: String\n) {\n  viewers(searchTerm: $searchText) {\n    edges {\n      node {\n        id\n        company\n        email\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f1bb884419c06ab69d030515495e9e1";

export default node;
